<template>
  <div
    id="ZilicredOfferCardContainer"
    v-when-visible="triggerEventWhenElementIsVisible"
    class="ZilicredOfferCardContainer"
  >
    <AffiliateOfferCard
      :interest-rate="0.99"
      :max-duration="240"
      :max-amount="2000000"
      partner="ZILICRED"
      @action-forward-click="selectOffer"
      @brand-click="displayOfferDetailsModal = true"
      @offer-conditions-click="displayOfferDetailsModal = true"
    />
    <OfferDetailsModal
      v-if="displayOfferDetailsModal"
      :offer="offer"
      :busy="busy"
      :is-fullscreen-mobile="true"
      product-type="Consignado Imobiliário"
      :display-faqs="cptdFaq.length > 0"
      :display="displayOfferDetailsModal"
      @close="displayOfferDetailsModal = false"
      @openFaqs="displayFaqsModal = true"
      @submit="selectOffer"
    >
      <template #conditions>
        <article>
          <p class="condition">Valor mínimo</p>
          <p class="value">R$ R$ 50.000,00</p>
        </article>
        <article>
          <p class="condition">Valor máximo</p>
          <p class="value">R$ 2.000.000,00</p>
        </article>
        <article>
          <p class="condition">Parcelas</p>
          <p class="value">em até 240x</p>
        </article>
        <article>
          <p class="condition">Forma de pagamento</p>
          <p class="value">
            Débito automático direto na conta do Banco Digital ZiliCred
          </p>
        </article>
        <article>
          <p class="condition">Taxa de juros</p>
          <p class="value">a partir de 0,99% ao mês</p>
        </article>
      </template>
    </OfferDetailsModal>
    <CommomQuestionsComponent
      v-if="displayFaqsModal"
      subject="ZILICRED"
      :questions="cptdFaq"
      @close="displayFaqsModal = false"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import whenVisibleDirective from '@/aasgard/directives/when-visible'
import { PartnersFaq } from '~/helpers/partners/partnersFaq'
import { Partner } from '@/data/common'
import OfferDetailsModal from '~/components/commomComponents/modals/OfferDetailsModal.vue'
import CommomQuestionsComponent from '~/components/commomComponents/CommomQuestionsComponent.vue'
import AffiliateOfferCard from '~/aasgard/components/cards/AffiliateOfferCard.vue'
export default {
  name: 'ZilicredOfferCardContainer',
  components: {
    AffiliateOfferCard,
    CommomQuestionsComponent,
    OfferDetailsModal,
  },
  directives: {
    ...whenVisibleDirective,
  },
  data() {
    return {
      displayOfferDetailsModal: false,
      busy: false,
      displayFaqsModal: false,
      offer: {
        partner: Partner.ZILICRED,
      },
    }
  },
  computed: {
    ...mapGetters({
      gtHomeEquityLatestColdOfferRequest:
        'products/loans/home-equity/cold-offer/gtHomeEquityLatestColdOfferRequest',
      gtHomeEquityExtraQuestions:
        'products/loans/home-equity/cold-offer/gtHomeEquityExtraQuestions',
      gtUser: 'user/user/gtUser',
    }),
    cptdFaq() {
      return PartnersFaq[this.offer?.partner] ?? []
    },
  },
  mounted() {
    this.actInsertIntent({
      identifier: 'PARTNER_ZILICRED_VIEW',
    })
  },
  methods: {
    ...mapActions({
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
      actInsertIntent: 'user/intent/actInsertIntent',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
    }),
    triggerEventWhenElementIsVisible() {
      this.actEmitGaEvent({
        eventLabel: 'card-zilicred',
        eventCategory: 'card-zilicred',
        eventAction: 'result-page-visualization',
      })
    },
    async selectOffer() {
      this.busy = true
      this.actEmitGaEvent({
        eventLabel: 'card-zilicred',
        eventCategory: 'card-zilicred',
        eventAction: 'result-page-click',
      })

      this.actSetLastLoanInteraction('home-equity')

      this.$router.push({
        path: `/contratacao/home-equity-payroll/afiliados/${Partner.ZILICRED.toLowerCase()}/redirecionamento`,
      })

      this.busy = false
    },
  },
}
</script>
<style lang="scss"></style>
